import React from 'react';
import './SimchaWidget.css';
import templates from './templates';

const FONT_SIZE_MAP = { small: '0.58em', medium: '0.82em', large: '1.15em' };

const GreetingBanner = ({ text, bgColor, textColor, fontFamily, fontSize, symbol, borderStyle }) => {
  const sym = symbol !== undefined ? symbol : '✦';
  const fs  = FONT_SIZE_MAP[fontSize] || FONT_SIZE_MAP.medium;
  return (
    <div style={{
      backgroundColor: bgColor || '#1a3352',
      padding: '7px 14px',
      textAlign: 'center',
      flexShrink: 0,
      direction: 'rtl',
      ...borderStyle,
    }}>
      {sym && <span style={{ color: textColor || '#ffffff', fontSize: '0.6em' }}>{sym} </span>}
      <span style={{
        color: textColor || '#ffffff',
        fontSize: fs,
        fontWeight: 600,
        fontFamily: fontFamily || 'inherit',
        letterSpacing: '0.03em',
      }}>
        {text}
      </span>
      {sym && <span style={{ color: textColor || '#ffffff', fontSize: '0.6em' }}> {sym}</span>}
    </div>
  );
};

export const SimchaWidget = ({
  initialData = { simchas: [] },
  template = 'Cards',
  title = 'שמחות בקהילה',
  showTitle = true,
  scale = 1,
  bgColor,
  onSave
}) => {
  const TemplateComponent = templates[template] || templates.Cards;

  const showTopGreeting    = initialData.showTopGreeting    ?? false;
  const topGreeting        = initialData.topGreeting        || 'הקהילה מאחלת מזל טוב לכל בעלי השמחות!';
  const showBottomGreeting = initialData.showBottomGreeting ?? false;
  const bottomGreeting     = initialData.bottomGreeting     || 'ויזכו לאורך ימים ושנים טובות, אמן!';

  if (!showTopGreeting && !showBottomGreeting) {
    return (
      <TemplateComponent
        initialData={initialData}
        title={title}
        showTitle={showTitle}
        scale={scale}
        bgColor={bgColor}
        onSave={onSave}
      />
    );
  }

  return (
    <div style={{
      height: '100%',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      boxSizing: 'border-box',
      fontSize: 'inherit',
    }}>
      {showTopGreeting && (
        <GreetingBanner
          text={topGreeting}
          bgColor={initialData.topBgColor}
          textColor={initialData.topTextColor}
          fontFamily={initialData.topFontFamily}
          fontSize={initialData.topFontSize}
          symbol={initialData.topSymbol}
          borderStyle={{ borderBottom: '1px solid rgba(212,175,55,0.4)' }}
        />
      )}
      <div style={{ flex: 1, overflow: 'hidden', minHeight: 0 }}>
        <TemplateComponent
          initialData={initialData}
          title={title}
          showTitle={showTitle}
          scale={scale}
          bgColor={bgColor}
          onSave={onSave}
        />
      </div>
      {showBottomGreeting && (
        <GreetingBanner
          text={bottomGreeting}
          bgColor={initialData.bottomBgColor}
          textColor={initialData.bottomTextColor}
          fontFamily={initialData.bottomFontFamily}
          fontSize={initialData.bottomFontSize}
          symbol={initialData.bottomSymbol}
          borderStyle={{ borderTop: '1px solid rgba(212,175,55,0.4)' }}
        />
      )}
    </div>
  );
};